import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../../../../../shadcn/components/ui/card";
import ExclamationIcon from "../../../../../../icons/ExclamationIcon";
import GreenCheckIcon from "../../../../../../icons/GreenCheckIcon";
import { BetaForm as useBetaForm } from "@reusejs/react";
import { Input } from "../../../../../../shadcn/components/ui/input";
import { Button } from "../../../../../../shadcn/components/ui/button";
import { Label } from "../../../../../../shadcn/components/ui/label";
import CustomMultipleFileUploader from "../../../../../../components/banker/bidder/CustomMultipleFileUploader";
import CustomLoadingModal from "./CustomLoadingModal";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../../../../../shadcn/components/ui/dialog";
import {
  fetchFuzzyMatchDetails,
  fetchIDCardOCRDetails,
  getBidderByUuid,
  maskUploadedAadhaar,
  updateBidderForEvent,
} from "services/bidder";
import SwitchToOtherKYCModeNotification from "../SwitchToOtherKYCModeNotification";
interface KycDocumentsUploadComponentProps {
  activeStep: number;
  bidderUuid: any;
  bidder: any;
  setActiveStep: any;
  init: any;
}

export default function KycDocumentsUploadComponent({
  activeStep,
  bidderUuid,
  bidder,
  setActiveStep,
  init,
}: KycDocumentsUploadComponentProps) {
  const [modeSwitching, setModeSwitching] = useState(false);

  const handleSwitchToOffline = async (mode: any) => {
    console.log("mode: ", mode, bidderUuid);
    if (!bidderUuid) return;
    setModeSwitching(true);
    try {
      const data: any = await getBidderByUuid(bidderUuid);
      await updateBidderForEvent({
        uuid: bidderUuid,
        meta: {
          ...data?.meta,
          bid_application_flow_mode: "online",
        },
        kyc_verified: false,
        digio_request_status: "pending",
        kyc_data: {},
        digio_request_details: {},
        digio_kyc_data: {},
        digio_kyc_report: {},
      });
      window?.location?.reload();
    } catch (error) {
      console.log("error switching to Mode KYC: ", error);
      setModeSwitching(false);
    }
  };
  return (
    <div className="py-4">
      <SwitchToOtherKYCModeNotification
        switchMode="Online"
        handleSwitch={handleSwitchToOffline}
        switchingToModes={modeSwitching}
      />

      <div className="text-xs md:text-sm font-openSans text-brand-textGrey">
        Please enter the details below:
      </div>
      <div className="mt-4">
        <AuthorizedRepresentativeDocumentUploader
          bidderUuid={bidderUuid}
          bidder={bidder}
          arName={bidder?.meta?.name || ""}
          arPan={bidder?.meta?.pan || ""}
          setActiveStep={setActiveStep}
          activeStep={activeStep}
          init={init}
          setLoading={() => {}}
          setLoadingText={() => {}}
        />
      </div>
    </div>
  );
}

interface AuthorizedRepresentativeDocumentUploaderProps {
  bidderUuid: string;
  bidder?: any;
  loading?: boolean;
  setLoading: any;
  arName: string;
  arPan: string;
  setLoadingText: any;
  init: any;
  setActiveStep: any;
  activeStep: any;
}
const AuthorizedRepresentativeDocumentUploader = ({
  bidderUuid,
  bidder,
  loading,
  setLoading,
  arName,
  arPan,
  setLoadingText,
  init,
  activeStep,
  setActiveStep,
}: AuthorizedRepresentativeDocumentUploaderProps) => {
  const [renderKey, setRenderKey] = useState(0);
  const [arPanFiles, setArPanFiles] = useState<any[]>([]);
  const [arAadhaarFrontFiles, setArAadhaarFrontFiles] = useState<any[]>([]);
  const [arPanOCRData, setArPanOCRData] = useState<any>({});
  const [arAadhaarBackFiles, setArAadhaarBackFiles] = useState<any[]>([]);
  const [arAadhaarOCRData, setArAadhaarOCRData] = useState<any>({});

  const [panNameMismatchWarning, setPanNameMismatchWarning] =
    useState<string>("");
  const [aadhaarNameMismatchWarning, setAadhaarNameMismatchWarning] =
    useState<string>("");

  const [showNameMismatchModal, setShowNameMismatchModal] = useState(false);
  const [nameMismatchModalType, setNameMismatchModalType] = useState<
    "pan" | "aadhaar" | "both"
  >("pan");
  const [nameMismatchDetails, setNameMismatchDetails] = useState<{
    panDocumentName: string;
    aadhaarDocumentName: string;
    profileName: string;
  }>({ panDocumentName: "", aadhaarDocumentName: "", profileName: "" });

  const [panNameMismatchConfirmed, setPanNameMismatchConfirmed] =
    useState(false);
  const [aadhaarNameMismatchConfirmed, setAadhaarNameMismatchConfirmed] =
    useState(false);
  const [supportingDocuments, setSupportingDocuments] = useState<any[]>([]);
  const [nameMismatchReason, setNameMismatchReason] = useState<string>("");
  const [submitError, setSubmitError] = useState<string>("");
  const [isOcrLoading, setIsOcrLoading] = useState<boolean>(false);
  const [hasAutoAdvanced, setHasAutoAdvanced] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [submitLoadingText, setSubmitLoadingText] = useState<string>("");

  const supportingDocsUploaderRef = React.useRef<any>(null);
  const arAadhaarFrontUploaderRef = React.useRef<any>(null);
  const arAadhaarBackUploaderRef = React.useRef<any>(null);
  const arPanUploaderRef = React.useRef<any>(null);

  const form = useBetaForm({
    is_pan_verified: "",
    is_aadhar_front_verified: "",
    is_aadhar_back_verified: "",
    is_both_side_aadhar_uploaded: false,
  });
  const form_constraints = {
    is_pan_verified: {
      presence: {
        allowEmpty: false,
        message: "^Pan must be verified before submitting.",
      },
      inclusion: {
        within: [true],
        message: "^Pan must be verified before submitting.",
      },
    },
    is_aadhar_front_verified: {
      presence: {
        allowEmpty: false,
        message: "^Aadhar Front must be verified before submitting.",
      },
      inclusion: {
        within: [true],
        message: "^Aadhar Front must be verified before submitting.",
      },
    },
    is_aadhar_back_verified: {
      presence: {
        allowEmpty: false,
        message: "^Aadhar Back must be verified before submitting.",
      },
      inclusion: {
        within: [true],
        message: "^Aadhar Back must be verified before submitting.",
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.value]);

  useEffect(() => {
    if (bidder?.kyc_data) {
      const kycData = bidder.kyc_data;

      if (kycData.pan) {
        setArPanFiles([{ id: kycData.pan }]);
        form.setField("pan_uuid", kycData.pan);
        if (kycData.pan_ocr_data) {
          setArPanOCRData({
            detections: [{ id_attributes: kycData.pan_ocr_data }],
          });
        }
        form.setField("is_pan_verified", true);
        if (kycData.pan_name_mismatch_confirmed) {
          setPanNameMismatchConfirmed(true);
        }
      }

      if (kycData.aadhaar_front) {
        setArAadhaarFrontFiles([{ id: kycData.aadhaar_front }]);
      }

      if (kycData.aadhaar_back) {
        setArAadhaarBackFiles([{ id: kycData.aadhaar_back }]);
      }

      if (kycData.aadhaar_ocr_data) {
        setArAadhaarOCRData({
          detections: [{ id_attributes: kycData.aadhaar_ocr_data }],
        });
      }

      if (kycData.aadhaar_front && kycData.aadhaar_back) {
        form.setField("is_aadhar_front_verified", true);
        form.setField("is_aadhar_back_verified", true);
        form.setField("is_both_side_aadhar_uploaded", true);
        if (kycData.aadhaar_name_mismatch_confirmed) {
          setAadhaarNameMismatchConfirmed(true);
        }
      }

      if (kycData.name_mismatch_reason) {
        setNameMismatchReason(kycData.name_mismatch_reason);
      }

      if (
        kycData.name_mismatch_supporting_documents &&
        Array.isArray(kycData.name_mismatch_supporting_documents) &&
        kycData.name_mismatch_supporting_documents.length > 0
      ) {
        const supportingDocs = kycData.name_mismatch_supporting_documents.map(
          (docId: string) => ({ id: docId }),
        );
        setSupportingDocuments(supportingDocs);
      }

      setRenderKey((prev) => prev + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bidder?.kyc_data, arName]);

  useEffect(() => {
    if (bidder?.kyc_data?.status !== "completed") {
      setHasAutoAdvanced(false);
    }
  }, [bidder?.kyc_data?.status]);

  useEffect(() => {
    const checkAndAutoAdvance = async () => {
      if (bidder?.kyc_data?.status === "completed" && !hasAutoAdvanced) {
        try {
          setHasAutoAdvanced(true);
          setLoading(true);
          setLoadingText("Updating verification step...");
          await updateBidderForEvent({
            uuid: bidderUuid,
            verification_step: "offline_kyc",
          });
          await init();
          setActiveStep(activeStep + 1);
          setLoading(false);
          setLoadingText("");
        } catch (error) {
          console.error("Error auto-advancing verification step:", error);
          setHasAutoAdvanced(false); // Reset on error so it can retry
          setLoading(false);
          setLoadingText("");
        }
      }
    };
    if (bidder && !hasAutoAdvanced) {
      checkAndAutoAdvance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bidder?.kyc_data?.status, hasAutoAdvanced]);
  const handlePanDocumentChange = async (data: any) => {
    if (data?.[0]?.id) {
      setLoading(true);
      setLoadingText("Verifying PAN details. Please wait...");
      form.removeError("is_pan_verified");
      form.setField("is_pan_verified", false);
      setPanNameMismatchWarning("");

      let res: any = null;
      let attempt = 0;
      let success = false;

      setIsOcrLoading(true);
      while (attempt < 3 && !success) {
        try {
          res = await fetchIDCardOCRDetails({
            enable_both_sides: false,
            check_id_match: false,
            front_part: data?.[0]?.id,
          });

          if (res?.detections?.length) {
            success = true;
            form.removeError("is_pan_verified");
          }
        } catch (error: any) {
          if (error?.response?.status === 400) {
            const message: any = error?.response?.data?.errorMessage;
            form.setErrors({ is_pan_verified: [message] });
            attempt = 4;
          }
          if (error?.response?.status >= 500) {
            const message: any = error?.response?.data?.errorMessage;
            form.setErrors({ is_pan_verified: [message] });
            attempt = 4;
          }
          attempt++;
          if (attempt < 3) {
            await new Promise((resolve) => setTimeout(resolve, 18000));
            if (attempt === 1) {
              setLoadingText(
                "This is taking longer than expected. Please wait a moment...",
              );
            }
          } else if (attempt === 3) {
            const message: any = error?.response?.data?.errorMessage;
            form.setErrors({ is_pan_verified: [message] });
          }
        }
      }

      setIsOcrLoading(false);
      if (!success) {
        await arPanUploaderRef.current?.deleteFile(data?.[0]?.id);
        form.setField("is_pan_verified", false);
        setLoading(false);
        setLoadingText("");
        return;
      }

      if (res?.detections?.length > 0) {
        const detection = res.detections[0];

        if (detection.id_type !== "PAN") {
          setIsOcrLoading(false);
          form.setErrors({
            is_pan_verified: ["Please upload a valid PAN document."],
          });
          setLoading(false);
          await arPanUploaderRef.current?.deleteFile(data?.[0]?.id);
          return;
        }

        if (detection?.detected_part !== "FRONT") {
          setIsOcrLoading(false);
          form.setErrors({
            is_pan_verified: [
              "Upload a valid FRONT side of your PAN document to continue.",
            ],
          });
          setLoading(false);
          await arPanUploaderRef.current?.deleteFile(data?.[0]?.id);
          return;
        }
        if (
          detection?.id_attributes?.id_no?.toLowerCase() !==
          arPan?.toLowerCase()
        ) {
          setIsOcrLoading(false);
          form.setErrors({
            is_pan_verified: [
              `The uploaded PAN (${
                detection?.id_attributes?.id_no ?? ""
              }) does not match the PAN (${
                arPan ?? ""
              }) registered in your profile.`,
            ],
          });
          setLoading(false);
          await arPanUploaderRef.current?.deleteFile(data?.[0]?.id);
          return;
        }
        const fuzzyMatchPayload: any = {
          context: "name",
          target_text: arName,
          source_text: detection?.id_attributes?.name || "",
        };

        const res2: any = await fetchFuzzyMatchDetails(fuzzyMatchPayload);
        console.log("res2: ", res2);

        // If name doesn't match (even with fuzzy matching), store mismatch info
        if (!res2?.matched && res2?.match_score < 50) {
          // Store OCR data and set warning
          setIsOcrLoading(false);
          form.setErrors({
            is_pan_verified: [
              `Name mismatch below threshold. The name on the document (${
                fuzzyMatchPayload["source_text"]?.toUpperCase() ?? ""
              }) does not match the name in your profile (${
                arName?.toUpperCase() ?? ""
              }). The matching score is below the required threshold. Please contact support for assistance or try again.`,
            ],
          });
          setLoading(false);
          await arPanUploaderRef.current?.deleteFile(data?.[0]?.id);
          return;
        } else if (!res2?.matched) {
          // Store OCR data and set warning
          setArPanOCRData(res);
          setPanNameMismatchWarning(
            `Name mismatch detected. Document name: ${fuzzyMatchPayload[
              "source_text"
            ]?.toUpperCase()}, Profile name is: ${arName?.toUpperCase()}. Please ensure the document belongs to Your Profile.`,
          );
          // Don't mark as verified - user needs to confirm via modal
          form.setField("is_pan_verified", false);
          form.removeError("is_pan_verified");
        } else {
          // Name matches - mark as verified
          setPanNameMismatchWarning("");
          setPanNameMismatchConfirmed(false);
          form.setField("is_pan_verified", true);
          setArPanOCRData(res);
        }
      }
      form.setField("pan_uuid", data?.[0]?.id || "");
      setArPanFiles(data);
      setIsOcrLoading(false);
      setLoadingText("");
      setLoading(false);
    }
  };

  const handlePanDocumentRemove = async () => {
    if (arPanFiles?.[0]?.id) {
      setLoading(true);
      setLoadingText("Removing PAN document. Please wait...");

      await arPanUploaderRef.current?.deleteFile(arPanFiles[0].id);
      setArPanFiles([]);
      setArPanOCRData({});
      setPanNameMismatchWarning("");
      setPanNameMismatchConfirmed(false);
      form.setField("is_pan_verified", false);
      form.setField("pan_uuid", "");
      form.removeError("is_pan_verified");

      setLoading(false);
      setLoadingText("");
    }
  };

  const handleAadhaarFrontRemove = async () => {
    if (arAadhaarFrontFiles?.[0]?.id) {
      setLoading(true);
      setLoadingText("Removing Aadhaar front document. Please wait...");

      await arAadhaarFrontUploaderRef.current?.deleteFile(
        arAadhaarFrontFiles[0].id,
      );

      setArAadhaarFrontFiles([]);
      form.setField("is_aadhar_front_verified", false);
      form.setField("is_both_side_aadhar_uploaded", false);
      form.removeError("is_aadhar_front_verified");

      if (form.getField("is_aadhar_back_verified") === true) {
        form.setField("is_aadhar_back_verified", false);
        form.removeError("is_aadhar_back_verified");
        setArAadhaarOCRData({});
        setAadhaarNameMismatchWarning("");
        setAadhaarNameMismatchConfirmed(false);
      }

      setLoading(false);
      setLoadingText("");
    }
  };

  const handleAadhaarBackRemove = async () => {
    if (arAadhaarBackFiles?.[0]?.id) {
      setLoading(true);
      setLoadingText("Removing Aadhaar back document. Please wait...");

      await arAadhaarBackUploaderRef.current?.deleteFile(
        arAadhaarBackFiles[0].id,
      );

      setArAadhaarBackFiles([]);
      form.setField("is_aadhar_back_verified", false);
      form.setField("is_both_side_aadhar_uploaded", false);
      form.removeError("is_aadhar_back_verified");

      if (form.getField("is_aadhar_front_verified") === true) {
        form.setField("is_aadhar_front_verified", false);
        form.removeError("is_aadhar_front_verified");
        setArAadhaarOCRData({});
        setAadhaarNameMismatchWarning("");
        setAadhaarNameMismatchConfirmed(false);
      }

      setLoading(false);
      setLoadingText("");
    }
  };
  const handleAadhaarDocumentVerification = async (
    arAadhaarFrontFiles: any,
    arAadhaarBackFiles: any,
  ) => {
    if (arAadhaarFrontFiles.length > 0 && arAadhaarBackFiles.length > 0) {
      setLoadingText("");
      setLoading(true);
      setLoadingText("Verifying Aadhaar details. Please wait...");
      form.removeError("is_aadhar_front_verified");
      form.removeError("is_aadhar_back_verified");
      form.setField("is_both_side_aadhar_uploaded", false);
      form.setField("is_aadhar_front_verified", false);
      form.setField("is_aadhar_back_verified", false);
      setAadhaarNameMismatchWarning("");

      let res: any = null;
      let attempt = 0;
      let success = false;

      setIsOcrLoading(true);
      while (attempt < 3 && !success) {
        try {
          res = await fetchIDCardOCRDetails({
            enable_both_sides: true,
            check_id_match: false,
            front_part: arAadhaarFrontFiles?.[0]?.id,
            back_part: arAadhaarBackFiles?.[0]?.id,
          });
          if (res?.detections?.length) {
            success = true;
            form.removeError("is_aadhar_back_verified");
          }
        } catch (error: any) {
          if (error?.response?.status === 400) {
            const message: any = error?.response?.data?.errorMessage;
            form.setErrors({ is_aadhar_back_verified: [message] });
            attempt = 4;
          }
          if (error?.response?.status >= 500) {
            const message: any = error?.response?.data?.errorMessage;
            form.setErrors({ is_aadhar_back_verified: [message] });
            attempt = 4;
          }
          attempt++;
          if (attempt < 3) {
            await new Promise((resolve) => setTimeout(resolve, 18000));
            setLoadingText(
              "This is taking longer than expected. Please wait a moment...",
            );
          } else if (attempt === 3) {
            const message: any = error?.response?.data?.errorMessage;
            form.setErrors({ is_aadhar_back_verified: [message] });
          }
        }
      }

      setIsOcrLoading(false);
      if (!success) {
        await arAadhaarFrontUploaderRef.current?.deleteFile(
          arAadhaarFrontFiles?.[0]?.id,
        );
        await arAadhaarBackUploaderRef.current?.deleteFile(
          arAadhaarBackFiles?.[0]?.id,
        );
        form.setField("is_both_side_aadhar_uploaded", false);
        setLoadingText("");
        setLoading(false);
        return;
      }

      if (res?.detections?.length > 0) {
        const detection = res.detections[0];
        if (detection.id_type !== "AADHAAR") {
          setIsOcrLoading(false);
          form.setErrors({
            is_aadhar_back_verified: [
              "Please upload a valid Aadhaar document.",
            ],
          });
          setLoading(false);
          await arAadhaarFrontUploaderRef.current?.deleteFile(
            arAadhaarFrontFiles?.[0]?.id,
          );
          await arAadhaarBackUploaderRef.current?.deleteFile(
            arAadhaarBackFiles?.[0]?.id,
          );
          return;
        }
        if (detection?.detected_part !== "BOTH") {
          setIsOcrLoading(false);
          form.setErrors({
            is_aadhar_back_verified: [
              "Please upload both FRONT and BACK sides of your Aadhaar document to continue.",
            ],
          });
          setLoading(false);
          await arAadhaarFrontUploaderRef.current?.deleteFile(
            arAadhaarFrontFiles?.[0]?.id,
          );
          await arAadhaarBackUploaderRef.current?.deleteFile(
            arAadhaarBackFiles?.[0]?.id,
          );
          return;
        }

        const fuzzyMatchPayload: any = {
          context: "name",
          target_text: arName,
          source_text: detection?.id_attributes?.name || "",
        };

        const res2: any = await fetchFuzzyMatchDetails(fuzzyMatchPayload);
        if (!res2?.matched && res2?.match_score < 50) {
          setIsOcrLoading(false);
          form.setErrors({
            is_aadhar_back_verified: [
              `Name mismatch below threshold. Document name: ${fuzzyMatchPayload[
                "source_text"
              ]?.toUpperCase()}, Profile Name is: ${arName?.toUpperCase()}. The matching score is below the required threshold. Please contact support for assistance or try again.`,
            ],
          });
          setLoading(false);
          await arAadhaarFrontUploaderRef.current?.deleteFile(
            arAadhaarFrontFiles?.[0]?.id,
          );
          await arAadhaarBackUploaderRef.current?.deleteFile(
            arAadhaarBackFiles?.[0]?.id,
          );
          return;
        } else if (!res2?.matched) {
          setArAadhaarOCRData(res);
          setAadhaarNameMismatchWarning(
            `Name mismatch detected. Document name: ${fuzzyMatchPayload[
              "source_text"
            ]?.toUpperCase()}, Profile Name is: ${arName?.toUpperCase()}. Please ensure the document belongs to Your Profile.`,
          );
          form.setField("is_aadhar_front_verified", false);
          form.setField("is_aadhar_back_verified", false);
          form.setField("is_both_side_aadhar_uploaded", false);
          form.removeError("is_aadhar_front_verified");
          form.removeError("is_aadhar_back_verified");
        } else {
          setAadhaarNameMismatchWarning("");
          setAadhaarNameMismatchConfirmed(false);
          form.setField("is_aadhar_front_verified", true);
          form.setField("is_aadhar_back_verified", true);
          form.setField("is_both_side_aadhar_uploaded", true);
          setArAadhaarOCRData(res);
        }
      }

      setIsOcrLoading(false);
      setLoadingText("");
      setLoading(false);
    }
  };

  const handleNameMismatchConfirm = () => {
    const needsPanConfirm =
      nameMismatchModalType === "pan" || nameMismatchModalType === "both";
    const needsAadhaarConfirm =
      nameMismatchModalType === "aadhaar" || nameMismatchModalType === "both";

    const panReady =
      !needsPanConfirm ||
      (panNameMismatchConfirmed && supportingDocuments.length > 0);
    const aadhaarReady =
      !needsAadhaarConfirm ||
      (aadhaarNameMismatchConfirmed && supportingDocuments.length > 0);
    if (!nameMismatchReason || nameMismatchReason.trim() === "") {
      return;
    }

    if (panReady && aadhaarReady) {
      if (needsPanConfirm) {
        form.setField("is_pan_verified", true);
      }
      if (needsAadhaarConfirm) {
        form.setField("is_aadhar_front_verified", true);
        form.setField("is_aadhar_back_verified", true);
        form.setField("is_both_side_aadhar_uploaded", true);
      }
      setShowNameMismatchModal(false);
      setPanNameMismatchWarning("");
      setAadhaarNameMismatchWarning("");
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    setSubmitError("");

    const hasPanMismatch = panNameMismatchWarning.length > 0;
    const hasAadhaarMismatch = aadhaarNameMismatchWarning.length > 0;

    const panNeedsConfirm =
      hasPanMismatch &&
      (!panNameMismatchConfirmed ||
        supportingDocuments.length === 0 ||
        !nameMismatchReason ||
        nameMismatchReason.trim() === "");
    const aadhaarNeedsConfirm =
      hasAadhaarMismatch &&
      (!aadhaarNameMismatchConfirmed ||
        supportingDocuments.length === 0 ||
        !nameMismatchReason ||
        nameMismatchReason.trim() === "");

    if (panNeedsConfirm || aadhaarNeedsConfirm) {
      setLoading(false);
      if (!showNameMismatchModal) {
        const modalType =
          panNeedsConfirm && aadhaarNeedsConfirm
            ? "both"
            : panNeedsConfirm
            ? "pan"
            : "aadhaar";
        setNameMismatchModalType(modalType);
        setNameMismatchDetails({
          panDocumentName:
            arPanOCRData?.detections?.[0]?.id_attributes?.name || "",
          aadhaarDocumentName:
            arAadhaarOCRData?.detections?.[0]?.id_attributes?.name || "",
          profileName: arName || "",
        });
        setShowNameMismatchModal(true);
      }
      return;
    }

    if (
      !hasPanMismatch ||
      (panNameMismatchConfirmed && supportingDocuments.length > 0)
    ) {
      form.setField("is_pan_verified", true);
    }
    if (
      !hasAadhaarMismatch ||
      (aadhaarNameMismatchConfirmed && supportingDocuments.length > 0)
    ) {
      form.setField("is_aadhar_front_verified", true);
      form.setField("is_aadhar_back_verified", true);
      form.setField("is_both_side_aadhar_uploaded", true);
    }

    if (form.validate()) {
      setIsSubmitting(true);
      setSubmitLoadingText("Saving the Bidder KYC details. Please wait...");
      setLoadingText("Saving the Bidder KYC details. Please wait...");

      try {
        const data: any = await getBidderByUuid(bidderUuid);

        const supportingDocs = supportingDocuments.map(
          (doc: any) => doc.id || doc,
        );

        let aadhaarFrontData: any = null;
        if (arAadhaarFrontFiles?.[0]?.id) {
          try {
            aadhaarFrontData = await maskUploadedAadhaar({
              aadhaar_uuid: arAadhaarFrontFiles?.[0]?.id,
              aadhaar_side: "front",
            });
          } catch (error) {
            console.log("error: ", error);
          }
        }
        let aadhaarBackData: any = null;
        if (arAadhaarBackFiles?.[0]?.id) {
          try {
            aadhaarBackData = await maskUploadedAadhaar({
              aadhaar_uuid: arAadhaarBackFiles?.[0]?.id,
              aadhaar_side: "back",
            });
          } catch (error) {
            console.log("error: ", error);
          }
        }
        setSubmitLoadingText("Processing documents and saving data...");
        await updateBidderForEvent({
          uuid: bidderUuid,
          meta: {
            ...data?.meta,
            steps_status: {
              ...data?.meta?.steps_status,
              offline_kyc: "completed",
            },
          },
          kyc_data: {
            ...data?.kyc_data,
            status: "completed",
            pan: arPanFiles?.[0]?.id || "",
            aadhaar_front:
              aadhaarFrontData?.data?.uuid ||
              arAadhaarFrontFiles?.[0]?.id ||
              "",
            aadhaar_back:
              aadhaarBackData?.data?.uuid || arAadhaarBackFiles?.[0]?.id || "",
            pan_name_mismatch_confirmed: panNameMismatchConfirmed || false,
            aadhaar_name_mismatch_confirmed:
              aadhaarNameMismatchConfirmed || false,
            name_mismatch_supporting_documents: supportingDocs,
            name_mismatch_reason: nameMismatchReason || "",
            is_name_mismatch_supporting_documents_uploaded:
              supportingDocs.length > 0,
            pan_ocr_data: arPanOCRData?.detections?.[0]?.id_attributes,
            aadhaar_ocr_data: arAadhaarOCRData?.detections?.[0].id_attributes,
            verification_status: "pending",
            // Clear rejection-related fields
            reject_remarks: null,
          },
          verification_step: "offline_kyc",
          status: "pending",
        });
        //handle file delete here later

        setSubmitLoadingText("Redirecting to the next step. Please wait...");
        await new Promise((resolve) => setTimeout(resolve, 1000));
        setActiveStep(activeStep + 1);
        await init();
        setIsSubmitting(false);
        setSubmitLoadingText("");
        setLoadingText("");
        setLoading(false);
      } catch (error: any) {
        setIsSubmitting(false);
        setSubmitLoadingText("");
        setLoading(false);
        setLoadingText("");
        setSubmitError("Something went wrong. Please try again.");
        console.error("Error updating bidder KYC data:", error);
      }
    } else {
      setLoading(false);
    }
  };

  return (
    <div className="font-openSans">
      {/* OCR Loading Modal */}
      <CustomLoadingModal
        isOpen={isOcrLoading}
        loadingText="We are fetching the document details, please wait..."
      />
      {/* Submit Loading Modal */}
      <CustomLoadingModal
        isOpen={isSubmitting}
        loadingText={
          submitLoadingText || "Processing your request. Please wait..."
        }
      />
      {/* Name Mismatch Confirmation Modal */}
      <Dialog
        open={showNameMismatchModal}
        onOpenChange={setShowNameMismatchModal}
      >
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-lg text-brand-orange flex items-center gap-2">
              Name Mismatch Detected
            </DialogTitle>
            <DialogDescription className="text-xs lg:text-sm text-gray-600 mt-2">
              {nameMismatchModalType === "both"
                ? "There are name mismatches between your PAN and Aadhaar documents and your profile name."
                : `There is a name mismatch between your ${
                    nameMismatchModalType === "pan" ? "PAN" : "Aadhaar"
                  } document and your profile name.`}
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-3">
            {/* Name Comparison */}
            <div className="px-4 py-2 bg-yellow-50 border border-yellow-200 rounded">
              <div className="space-y-1">
                <p className="text-xs lg:text-sm font-semibold text-gray-700">
                  Profile Name:
                </p>
                <p className="text-xs lg:text-sm text-gray-600">
                  {nameMismatchDetails.profileName}
                </p>

                {/* PAN Details - Show if PAN mismatch or both */}
                {(nameMismatchModalType === "pan" ||
                  nameMismatchModalType === "both") && (
                  <div className="mt-4 pt-4 border-t border-yellow-300">
                    <p className="text-xs lg:text-sm font-semibold text-gray-700">
                      PAN Document Name:
                    </p>
                    <p className="text-xs lg:text-sm text-gray-600">
                      {nameMismatchDetails.panDocumentName || "N/A"}
                    </p>
                  </div>
                )}

                {/* Aadhaar Details - Show if Aadhaar mismatch or both */}
                {(nameMismatchModalType === "aadhaar" ||
                  nameMismatchModalType === "both") && (
                  <div className="mt-4 pt-4 border-t border-yellow-300">
                    <p className="text-xs lg:text-sm font-semibold text-gray-700">
                      Aadhaar Document Name:
                    </p>
                    <p className="text-sm text-gray-600">
                      {nameMismatchDetails.aadhaarDocumentName || "N/A"}
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* PAN Confirmation Checkbox - Show if PAN mismatch or both */}
            {(nameMismatchModalType === "pan" ||
              nameMismatchModalType === "both") && (
              <div className="flex items-start gap-3 p-4 bg-gray-50 border border-gray-200 rounded">
                <input
                  type="checkbox"
                  id="pan-name-mismatch-confirm"
                  checked={panNameMismatchConfirmed}
                  onChange={(e) =>
                    setPanNameMismatchConfirmed(e.target.checked)
                  }
                  className="mt-1 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label
                  htmlFor="pan-name-mismatch-confirm"
                  className="text-sm text-gray-700 cursor-pointer"
                >
                  I confirm that I am doing this intentionally for PAN and the
                  document belongs to me. I understand that the name on the
                  document may differ from my profile name due to legal name
                  changes, marriage, or other valid reasons.
                </label>
              </div>
            )}

            {/* Aadhaar Confirmation Checkbox - Show if Aadhaar mismatch or both */}
            {(nameMismatchModalType === "aadhaar" ||
              nameMismatchModalType === "both") && (
              <div className="flex items-start gap-3 p-4 bg-gray-50 border border-gray-200 rounded">
                <input
                  type="checkbox"
                  id="aadhaar-name-mismatch-confirm"
                  checked={aadhaarNameMismatchConfirmed}
                  onChange={(e) =>
                    setAadhaarNameMismatchConfirmed(e.target.checked)
                  }
                  className="mt-1 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label
                  htmlFor="aadhaar-name-mismatch-confirm"
                  className="text-sm text-gray-700 cursor-pointer"
                >
                  I confirm that I am doing this intentionally for Aadhaar and
                  the document belongs to me. I understand that the name on the
                  document may differ from my profile name due to legal name
                  changes, marriage, or other valid reasons.
                </label>
              </div>
            )}

            {/* Name Mismatch Reason Input */}
            <div className="space-y-2">
              <Label
                htmlFor="name_mismatch_reason"
                className="text-sm font-semibold text-gray-700"
              >
                Reason for Name Mismatch <span className="text-red-500">*</span>
              </Label>
              <p className="text-xs text-gray-500">
                Please provide a reason for the name mismatch (e.g., legal name
                change, marriage, etc.)
              </p>
              <Input
                id="name_mismatch_reason"
                type="text"
                placeholder="Enter reason for name mismatch"
                value={nameMismatchReason}
                onChange={(e) => setNameMismatchReason(e.target.value)}
                className="w-full border-[1px] border-brand-borderLightGray py-2 px-4 text-sm tracking-wide font-sans text-brand-textBlack rounded"
                required
              />
            </div>

            {/* Supporting Documents Upload - Single uploader for all name mismatch cases */}
            <div className="space-y-2">
              <p className="text-sm font-semibold text-gray-700">
                Upload Supporting Documents (Required)
              </p>
              <p className="text-xs text-gray-500">
                Please upload any supporting documents (e.g., marriage
                certificate, gazette notification, legal name change document,
                etc.) that verify why the name on your document(s) may differ
                from your profile name. You can upload any document type.
              </p>
              <CustomMultipleFileUploader
                key={renderKey + "-supporting-docs"}
                handleChange={(data: any) => {
                  setSupportingDocuments(data || []);
                }}
                allowedMimeTypes={[
                  "application/pdf",
                  "image/png",
                  "image/jpeg",
                  "image/jpg",
                  "image/gif",
                  "image/webp",
                ]}
                property_uuid={bidderUuid}
                owner_service_type="name_mismatch_supporting"
                data={supportingDocuments}
                maxAllowed={5}
                defaultText="Upload supporting documents (PDF, Images, etc.)"
                ref={supportingDocsUploaderRef}
              />
            </div>
          </div>

          <DialogFooter className="mt-6">
            <Button
              type="button"
              variant="outline"
              onClick={() => {
                setShowNameMismatchModal(false);
                setNameMismatchReason("");
              }}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              type="button"
              onClick={handleNameMismatchConfirm}
              disabled={
                loading ||
                !nameMismatchReason ||
                nameMismatchReason.trim() === "" ||
                (nameMismatchModalType === "pan"
                  ? !panNameMismatchConfirmed ||
                    supportingDocuments.length === 0
                  : nameMismatchModalType === "aadhaar"
                  ? !aadhaarNameMismatchConfirmed ||
                    supportingDocuments.length === 0
                  : // "both" case - both must be confirmed and have supporting docs
                    !panNameMismatchConfirmed ||
                    !aadhaarNameMismatchConfirmed ||
                    supportingDocuments.length === 0)
              }
              className="bg-blue-600 hover:bg-blue-700"
            >
              Confirm & Continue
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <div>
        {bidder.kyc_data?.status === "completed" && (
          <div className="mb-6">
            <div className="border-[1px] border-green-300 bg-green-50 px-4 py-3 rounded-md">
              <div className="flex gap-2 md:gap-3">
                <div className="flex-shrink-0 mt-0.5">
                  <GreenCheckIcon className="text-green-600" />
                </div>
                <div className="flex-1">
                  <div className="text-sm md:text-base font-semibold text-green-700 mb-2">
                    KYC Completed
                  </div>
                  <div className="text-xs md:text-sm text-green-700 leading-relaxed">
                    Your KYC documents have been successfully verified. You will
                    be automatically redirected to the next step.
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {bidder.kyc_data?.status === "rejected" && (
          <div className="mb-6">
            <div className="border-[1px] border-red-300 bg-red-50 px-4 py-3 rounded-md">
              <div className="flex gap-2 md:gap-3">
                <div className="flex-shrink-0 mt-0.5">
                  <ExclamationIcon className="text-red-600" />
                </div>
                <div className="flex-1">
                  <div className="text-sm md:text-base font-semibold text-red-700 mb-2">
                    KYC Rejected
                  </div>
                  <div className="text-xs md:text-sm text-red-600 mb-2">
                    <span className="font-semibold">Rejection Remarks:</span>{" "}
                    {bidder.kyc_data?.reject_remarks ||
                      "No rejection remarks provided"}
                  </div>
                  <div className="text-xs md:text-sm text-red-700 leading-relaxed">
                    Please upload the required documents again to complete the
                    KYC process.
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="mt-4 text-sm font-semibold">PAN</div>
        <div className="mt-4 max-w-xl">
          {form.getField("is_pan_verified") === true &&
          arPanFiles.length > 0 ? (
            <div className="border rounded p-4 bg-brand-bgLightGrey">
              <div className="flex flex-col items-center mb-3">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${arPanFiles[0].id}`}
                  alt="PAN"
                  className="w-auto h-32 object-contain mb-2 border opacity-10"
                />
                <div className="flex items-center gap-2 mt-2">
                  <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  <p className="text-sm text-green-500 capitalize font-semibold">
                    PAN is verified successfully
                  </p>
                </div>
                {arPanOCRData?.detections?.[0]?.id_attributes?.name && (
                  <p className="text-xs text-gray-600 mt-1">
                    Name on document:{" "}
                    {arPanOCRData.detections[0].id_attributes.name}
                  </p>
                )}
              </div>
              <div className="flex justify-center mt-3">
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  onClick={handlePanDocumentRemove}
                  disabled={loading}
                  className="text-red-600 border-red-300 hover:bg-red-50"
                >
                  Remove Document
                </Button>
              </div>
            </div>
          ) : (
            <CustomMultipleFileUploader
              key={renderKey + "-ar-pan"}
              handleChange={handlePanDocumentChange}
              allowedMimeTypes={["image/png", "image/jpeg"]}
              property_uuid={bidderUuid}
              owner_service_type="ar_pan"
              data={arPanFiles}
              maxAllowed={1}
              defaultText="Please upload PAN*"
              ref={arPanUploaderRef}
            />
          )}
          {form.errors.get("is_pan_verified") ? (
            <p className="mt-1 text-sm text-red-500">
              {form.errors.get("is_pan_verified")[0]}
            </p>
          ) : null}
          {panNameMismatchWarning && (
            <div className="mt-2 p-3 bg-yellow-50 border border-yellow-200 rounded">
              <p className="text-xs lg:text-sm text-yellow-800 font-medium">
                ⚠️ Warning: {panNameMismatchWarning}
              </p>
            </div>
          )}
        </div>

        <div className="mt-4 text-sm font-semibold">Aadhaar Front and Back</div>

        <div className="mt-4 max-w-xl">
          {form.getField("is_aadhar_front_verified") === true &&
          arAadhaarFrontFiles.length > 0 ? (
            <div className="border rounded p-4 bg-brand-bgLightGrey">
              <div className="flex flex-col items-center mb-3">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${arAadhaarFrontFiles[0].id}`}
                  alt="Aadhaar Front"
                  className="w-auto h-32 object-contain mb-2 border opacity-10"
                />
                <div className="flex items-center gap-2 mt-2">
                  <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  <p className="text-sm text-green-500 capitalize font-semibold">
                    Aadhaar Front is verified successfully
                  </p>
                </div>
                {/* Document name from OCR if available */}
                {arAadhaarOCRData?.detections?.[0]?.id_attributes?.name && (
                  <p className="text-xs text-gray-600 mt-1">
                    Name on document:{" "}
                    {arAadhaarOCRData.detections[0].id_attributes.name}
                  </p>
                )}
              </div>
              <div className="flex justify-center mt-3">
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  onClick={handleAadhaarFrontRemove}
                  disabled={loading}
                  className="text-red-600 border-red-300 hover:bg-red-50"
                >
                  Remove Document
                </Button>
              </div>
            </div>
          ) : (
            <CustomMultipleFileUploader
              key={renderKey + "-ar-aadhaar-front"}
              handleChange={async (data: any) => {
                setArAadhaarFrontFiles(data);
                // Trigger verification only when both front and back are uploaded
                // This ensures we verify both sides together for Aadhaar
                if (data?.[0]?.id && arAadhaarBackFiles?.[0]?.id) {
                  form.setField("is_both_side_aadhar_uploaded", true);
                  await handleAadhaarDocumentVerification(
                    data,
                    arAadhaarBackFiles,
                  );
                }
              }}
              allowedMimeTypes={["image/png", "image/jpeg"]}
              property_uuid={bidderUuid}
              owner_service_type="ar_aadhaar-front"
              data={arAadhaarFrontFiles}
              maxAllowed={1}
              defaultText="Please upload Aadhaar Front*"
              ref={arAadhaarFrontUploaderRef}
            />
          )}
        </div>

        {/* Aadhaar Back Side Upload */}
        <div className="mt-4 max-w-xl">
          {/* Conditional rendering: Show verified state with remove button or uploader */}
          {form.getField("is_aadhar_back_verified") === true &&
          arAadhaarBackFiles.length > 0 ? (
            // Verified state: Display uploaded Aadhaar back with status and remove button
            <div className="border rounded p-4 bg-brand-bgLightGrey">
              <div className="flex flex-col items-center mb-3">
                {/* Display uploaded Aadhaar back image */}
                {/* Note: Using <img> instead of next/image as images are from external CDN (IMAGIX_URL) */}
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${arAadhaarBackFiles[0].id}`}
                  alt="Aadhaar Back"
                  className="w-auto h-32 object-contain mb-2 border opacity-10"
                />
                <div className="flex items-center gap-2 mt-2">
                  <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  <p className="text-sm text-green-500 capitalize font-semibold">
                    Aadhaar Back is verified successfully
                  </p>
                </div>
                {/* Document name from OCR if available */}
                {arAadhaarOCRData?.detections?.[0]?.id_attributes?.name && (
                  <p className="text-xs text-gray-600 mt-1">
                    Name on document:{" "}
                    {arAadhaarOCRData.detections[0].id_attributes.name}
                  </p>
                )}
              </div>
              <div className="flex justify-center mt-3">
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  onClick={handleAadhaarBackRemove}
                  disabled={loading}
                  className="text-red-600 border-red-300 hover:bg-red-50"
                >
                  Remove Document
                </Button>
              </div>
            </div>
          ) : (
            <CustomMultipleFileUploader
              key={renderKey + "-ar-aadhaar-back"}
              handleChange={async (data: any) => {
                setArAadhaarBackFiles(data);
                if (data?.[0]?.id && arAadhaarFrontFiles?.[0]?.id) {
                  form.setField("is_both_side_aadhar_uploaded", true);
                  await handleAadhaarDocumentVerification(
                    arAadhaarFrontFiles,
                    data,
                  );
                }
              }}
              allowedMimeTypes={["image/png", "image/jpeg"]}
              property_uuid={bidderUuid}
              owner_service_type="ar_aadhaar-back"
              data={arAadhaarBackFiles}
              maxAllowed={1}
              defaultText="Please upload Aadhaar Back*"
              ref={arAadhaarBackUploaderRef}
            />
          )}

          {form.errors.get("is_aadhar_back_verified") ? (
            <p className="mt-1 text-sm text-red-500">
              {form.errors.get("is_aadhar_back_verified")[0]}
            </p>
          ) : null}
          {aadhaarNameMismatchWarning && (
            <div className="mt-2 p-3 bg-yellow-50 border border-yellow-200 rounded">
              <p className="text-xs lg:text-sm text-yellow-800 font-medium">
                ⚠️ Warning: {aadhaarNameMismatchWarning}
              </p>
            </div>
          )}
        </div>

        {arPanFiles.length > 0 &&
          arAadhaarFrontFiles.length > 0 &&
          arAadhaarBackFiles.length > 0 && (
            <div className="mt-8">
              {submitError && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded">
                  <p className="text-sm text-red-600">{submitError}</p>
                </div>
              )}
              <div className="flex">
                <Button
                  disabled={loading || isSubmitting}
                  className="w-full max-w-xl h-10 text-[18px]"
                  onClick={handleSubmit}
                >
                  {loading || isSubmitting ? "Processing..." : "Next"}
                </Button>
              </div>
            </div>
          )}
      </div>
    </div>
  );
};
